export default {"src":"/_next/static/media/twitterIcon.6f26149e.svg","height":33,"width":33,"blurWidth":0,"blurHeight":0};